<template>
  <div>
    <form autocomplete="off" @submit.prevent="addCampo">
      <b-row>
        <b-col sm="6">
          <fcc-select
            class="mb-4"
            placeholder="Selecione um tipo de campo"
            labelField="campo"
            @input="selecionaEnum"
            v-model="enumSelecionado"
            :options="enumCampos"
            :clearable="false"
          >
            Selecione um tipo de campo
          </fcc-select>
        </b-col>
      </b-row>
      <template v-if="enumSelecionado.id != null">
        <b-row>
          <b-col sm="6">
            <fcc-input required v-model="mysqlMontando.nomeColuna">Nome da coluna</fcc-input>
          </b-col>
          <b-col sm="6" v-if="enumSelecionado.limit > 0">
            <fcc-input required v-model="mysqlMontando.tamanhoDeCampo">Tamanho máximo</fcc-input>
            Tamanho limite: {{ enumSelecionado.limit }}
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <span
              ><toggle-button v-model="mysqlMontando.aceitaNulo" :sync="true" /> Aceita nulo</span
            >
            <span class="ml-2"
              ><toggle-button v-model="mysqlMontando.chave" :sync="true" />Key</span
            >
            <template v-if="enumSelecionado.primaryKey">
              <span class="ml-2"
                ><toggle-button v-model="mysqlMontando.primaryKey" :sync="true" />Primary Key</span
              >
              <span class="ml-2"
                ><toggle-button v-model="mysqlMontando.autoIncrement" :sync="true" />Auto
                Increment</span
              >
            </template>
          </b-col>
        </b-row>
        <b-row class="mt-4 text-right">
          <b-col>
            <fcc-button tipo="submit">{{ labelsSystem.salvar }}</fcc-button>
          </b-col>
        </b-row>
      </template>
    </form>
    <b-row class="mt-4">
      <b-col>
        <fccTable
          striped
          hover
          :fields="fields"
          responsive
          porPage="100"
          titlePage="Tabela de campos"
          titlePDF="Tabela de campos"
          :actions="actions"
          :items="lstCamposMysql"
        >
        </fccTable>
      </b-col>
    </b-row>
    <b-row class="mt-4" v-if="lstCamposMysql.length > 0">
      <b-col class="text-right">
        <fcc-button @click="finalizandoCampo">Criar tabela</fcc-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import store from '../../../store'
import axios from 'axios'
export default {
  data() {
    return {
      lstTabelaSQL: {
        spi: this.spiItem.spi,
        listaCampos: []
      },
      tabela: this.spiItem.spi + '_inscr_web',
      fields: [
        { key: 'nomeColuna', label: 'Nome', active: true },
        { key: 'tamanhoDeCampo', label: 'Tamanho', active: true },
        { key: 'aceitaNulo', label: 'Aceita nulo', active: true },
        { key: 'chave', label: 'Chave', active: true },
        { key: 'actions', label: '', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'deleteCampo',
          icon: 'trash',
          tooltip: 'Deletar',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      mysqlMontando: {},
      lstCamposMysql: [],
      enumSelecionado: '',
      enumCampos: [
        {
          campo: 'Varchar',
          id: 0,
          limit: 255,
          aceitaNulo: true,
          chave: true,
          primaryKey: false,
          autoIncrement: false
        },
        {
          campo: 'Int',
          id: 1,
          limit: 11,
          aceitaNulo: true,
          chave: true,
          primaryKey: true,
          autoIncrement: true
        },
        {
          campo: 'Bit',
          id: 2,
          limit: 0,
          aceitaNulo: true,
          chave: true,
          primaryKey: false,
          autoIncrement: false
        },
        {
          campo: 'Char',
          id: 3,
          limit: 255,
          aceitaNulo: true,
          chave: true,
          primaryKey: true,
          autoIncrement: false
        },
        {
          campo: 'Date',
          id: 4,
          limit: 0,
          aceitaNulo: true,
          chave: true,
          primaryKey: false,
          autoIncrement: false
        },
        {
          campo: 'DateTime',
          id: 5,
          limit: 0,
          aceitaNulo: true,
          chave: true,
          primaryKey: false,
          autoIncrement: false
        },
        {
          campo: 'Decimal',
          id: 6,
          limit: 0,
          aceitaNulo: true,
          chave: true,
          primaryKey: false,
          autoIncrement: false
        },
        {
          campo: 'Float',
          id: 7,
          limit: 0,
          aceitaNulo: true,
          chave: true,
          primaryKey: false,
          autoIncrement: false
        },
        {
          campo: 'Image',
          id: 8,
          limit: 0,
          aceitaNulo: true,
          chave: true,
          primaryKey: false,
          autoIncrement: false
        },
        {
          campo: 'Money',
          id: 9,
          limit: 0,
          aceitaNulo: true,
          chave: true,
          primaryKey: false,
          autoIncrement: false
        },
        {
          campo: 'Tinyint',
          id: 10,
          limit: 0,
          aceitaNulo: true,
          chave: true,
          primaryKey: false,
          autoIncrement: false
        }
      ]
    }
  },
  props: {
    spiItem: Object
  },
  methods: {
    selecionaEnum() {
      this.mysqlMontando = {
        nomeColuna: '',
        tipoDeCampo: 0,
        tamanhoDeCampo: '',
        aceitaNulo: false,
        primaryKey: false,
        autoIncrement: false,
        chave: false
      }
    },
    addCampo() {
      const selecionado = {
        nomeColuna: this.mysqlMontando.nomeColuna,
        tipoDeCampo: this.enumSelecionado.id,
        tamanhoDeCampo: this.mysqlMontando.tamanhoDeCampo,
        aceitaNulo:
          this.mysqlMontando.aceitaNulo == null
            ? this.enumSelecionado.aceitaNulo
            : this.mysqlMontando.aceitaNulo,
        chave:
          this.mysqlMontando.chave == null ? this.enumSelecionado.chave : this.mysqlMontando.chave,
        primaryKey:
          this.mysqlMontando.primaryKey == null
            ? this.enumSelecionado.primaryKey
            : this.mysqlMontando.primaryKey,
        autoIncrement:
          this.mysqlMontando.autoIncrement == null
            ? this.enumSelecionado.autoIncrement
            : this.mysqlMontando.autoIncrement
      }
      this.lstCamposMysql.push(selecionado)
      this.mysqlMontando = {}
      this.enumSelecionado = ''
    },
    deleteCampo(_, item) {
      this.callConfirm('Deseja realmente excluir o campo?', item.nomeColuna).then((result) => {
        if (result.value) {
          this.lstCamposMysql = this.arrayRemove(this.lstCamposMysql, item)
        }
      })
    },
    finalizandoCampo() {
      this.callConfirm('Deseja criar a tabela', this.tabela).then(() => {
        this.lstTabelaSQL.listaCampos = this.lstCamposMysql
        axios
          .post(
            store.state.baseUrlPublicacao + 'Publicacao/CriarTabelaInscrWebPorSpi',
            this.lstTabelaSQL,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.lstCamposMysql = []
            this.callToast('Tabela adicionada com sucesso')
            this.$emit('fechaModal')
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      })
    }
  }
}
</script>
